import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./inputWrapper.html";
import { DEFAULT_NUMBER_OF_ROWS } from 'c360/textArea';
import { IS_DEVELOPMENT } from '~/config';
import { selectShowInputErrors, WireRouter } from '~/modules/stores/routerStore';
import { getCharactersRemainingText, i18nStore, WireI18n } from '../../../modules/stores/i18nStore';
class InputWrapper extends LightningElement {
  constructor(...args) {
    super(...args);
    this.label = '';
    this.overview = '';
    this.badge = '';
    this.type = 'text';
    this.maxLength = Number.MAX_VALUE;
    this.placeholder = '';
    this.value = '';
    this.disabled = false;
    this.forceShowError = false;
    this.showRemainingCharacters = false;
    this.helpText = '';
    this.helpTextWithoutIcon = false;
    this.helpTextTitle = '';
    this.helpInputMessage = '';
    this.linkTarget = '_self';
    this.required = false;
    this.textAreaRows = DEFAULT_NUMBER_OF_ROWS;
    this.changeCallback = void 0;
    this.widthClass = 'slds-size_3-of-4';
    this.hasToggle = false;
    this.maxValue = Number.MAX_VALUE;
    this.alwaysShowRemainingCharacters = false;
    this.requiredText = void 0;
    this.invalidUrlError = void 0;
    this.invalidEmailError = void 0;
    this.invalidOrgIdError = void 0;
    this.invalidCampaignIdError = void 0;
    this._helpTextTitle = '';
    this.getCharactersRemainingText = getCharactersRemainingText;
    this.routerShowInputErrors = void 0;
    this.onFocus = () => {
      const messageBox = this.template.querySelector('appx-message-box');
      if (messageBox) {
        messageBox.focused = true;
      }
    };
    this.onBlur = () => {
      const messageBox = this.template.querySelector('appx-message-box');
      if (messageBox) {
        messageBox.focused = false;
      }
    };
  }
  i18nConnected(i18n) {
    var _this$helpTextTitle;
    this.requiredText = i18n.shared.requiredField;
    this.invalidUrlError = i18n.shared.invalidUrl;
    this.invalidEmailError = i18n.shared.invalidEmail;
    this._helpTextTitle = (_this$helpTextTitle = this.helpTextTitle) !== null && _this$helpTextTitle !== void 0 ? _this$helpTextTitle : i18n.shared.noteMessageTitle;
    this.invalidOrgIdError = i18n.shared.invalidOrgId;
    this.invalidCampaignIdError = i18n.shared.invalidCampaignId;
  }
  get invalidMaxValueError() {
    return i18nStore.getState().i18n.shared.invalidMaxValue({
      MAX_VALUE: this.maxValue
    });
  }
  get isTextArea() {
    return this.type === 'textArea';
  }
  get isTextInput() {
    return this.type !== 'textArea';
  }
  get elementType() {
    return this.isTextArea ? 'c360-text-area' : 'c360-input';
  }
  get helpTextCss() {
    return this.label ? 'help-text' : 'help-text-no-label';
  }
  get widthClassCss() {
    return this.widthClass + ' slds-m-bottom_small';
  }
  get showInputErrors() {
    return this.forceShowError || this.routerShowInputErrors;
  }
  connectedCallback() {
    if (IS_DEVELOPMENT && !this.label && !this.ariaLabelledBy) {
      throw new Error('<appx-input-wrapper> was created without a label or aria-labelledby attribute, this is an accessibility issue. All inputs should have a label associated with them.');
    }
  }
  renderedCallback() {
    var _querySelector, _this$ariaLabelledBy;
    (_querySelector = this.template.querySelector(this.elementType)) === null || _querySelector === void 0 ? void 0 : _querySelector.setAttribute('aria-labelledby', (_this$ariaLabelledBy = this.ariaLabelledBy) !== null && _this$ariaLabelledBy !== void 0 ? _this$ariaLabelledBy : '');
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(InputWrapper, {
  publicProps: {
    label: {
      config: 0
    },
    overview: {
      config: 0
    },
    badge: {
      config: 0
    },
    type: {
      config: 0
    },
    maxLength: {
      config: 0
    },
    placeholder: {
      config: 0
    },
    value: {
      config: 0
    },
    disabled: {
      config: 0
    },
    forceShowError: {
      config: 0
    },
    showRemainingCharacters: {
      config: 0
    },
    helpText: {
      config: 0
    },
    helpTextWithoutIcon: {
      config: 0
    },
    helpTextTitle: {
      config: 0
    },
    helpInputMessage: {
      config: 0
    },
    linkTarget: {
      config: 0
    },
    required: {
      config: 0
    },
    textAreaRows: {
      config: 0
    },
    changeCallback: {
      config: 0
    },
    widthClass: {
      config: 0
    },
    hasToggle: {
      config: 0
    },
    maxValue: {
      config: 0
    },
    alwaysShowRemainingCharacters: {
      config: 0
    }
  },
  wire: {
    i18nConnected: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    routerShowInputErrors: {
      adapter: WireRouter,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectShowInputErrors
        };
      }
    }
  },
  fields: ["requiredText", "invalidUrlError", "invalidEmailError", "invalidOrgIdError", "invalidCampaignIdError", "_helpTextTitle", "getCharactersRemainingText", "onFocus", "onBlur"]
});
const __lwc_component_class_internal = _registerComponent(InputWrapper, {
  tmpl: _tmpl,
  sel: "appx-input-wrapper",
  apiVersion: 62
});
export default __lwc_component_class_internal;